/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EPaymentStatus = 'Paid' | 'Pending' | 'NoPaid' | 'Processing';

export const EPaymentStatus = {
    Paid: 'Paid' as EPaymentStatus,
    Pending: 'Pending' as EPaymentStatus,
    NoPaid: 'NoPaid' as EPaymentStatus,
    Processing: 'Processing' as EPaymentStatus
};

